import { apiClient } from './apiClient.js';

const listAdminUsers = async ({ limit = 20, paginationToken = null } = {}) => {
  const response = await apiClient.get('/api/admin/users', {
    params: {
      limit,
      pagination_token: paginationToken || undefined,
    },
  });
  return response.data;
};

const createAdminUser = async ({ email, temporaryPassword }) => {
  const response = await apiClient.post('/api/admin/users', {
    email,
    temporary_password: temporaryPassword || undefined,
  });
  return response.data;
};

const resetAdminUserTemporaryPassword = async ({ username, temporaryPassword }) => {
  const response = await apiClient.post(`/api/admin/users/${encodeURIComponent(username)}/reset-temporary-password`, {
    temporary_password: temporaryPassword || undefined,
  });
  return response.data;
};

const setAdminUserEnabled = async ({ username, enabled }) => {
  const endpoint = enabled ? 'enable' : 'disable';
  const response = await apiClient.post(`/api/admin/users/${encodeURIComponent(username)}/${endpoint}`);
  return response.data;
};

const listAdminUserGroups = async ({ username }) => {
  const response = await apiClient.get(`/api/admin/users/${encodeURIComponent(username)}/groups`);
  return response.data;
};

const updateAdminUserGroup = async ({ username, groupName, operation }) => {
  const response = await apiClient.post(`/api/admin/users/${encodeURIComponent(username)}/groups`, {
    group_name: groupName,
    operation,
  });
  return response.data;
};

export {
  listAdminUsers,
  createAdminUser,
  resetAdminUserTemporaryPassword,
  setAdminUserEnabled,
  listAdminUserGroups,
  updateAdminUserGroup,
};
